module.exports = "/assets/archetype-adaptation.webp"